import React from 'react'
import "./Banner_Badge_holder.css"
import Green_Check_Lottie from '../../Animation/green_check_lottie/Green_Check_Lottie'

function Banner_Badge_holder({text}) {
    return (
        <>
            <section className='Banner_Badge_holder'>
                <Green_Check_Lottie />
                <div className="text_holder">
                    <p>Pay Your Monthly {text}!</p>
                </div>
            </section>

        </>
    )
}

export default Banner_Badge_holder